export default __webpack_public_path__ + "static/media/Megosu-Lukas Bazle-8.2666e623.jpg";